<div class="mx-auto w-[90%]">
  <div class="mb-6 mt-10 flex justify-between text-center">
    <h1 class="text-start text-3xl font-bold">Detalle de venta</h1>
    <div class="flex gap-4">
      <button
        (click)="navigateToSepa()"
        class="btn hover:medium-green flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
      >
        <mat-icon aria-hidden="false" aria-label="icono contrato" fontIcon="visibility" />
        Ver Sepa
      </button>
      <ng-container *ngIf="!isEditMode">
        <button
          (click)="exportarExcel()"
          class="btn hover:medium-green flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
        >
          <mat-icon aria-hidden="false" aria-label="icono exportar venta" fontIcon="download" />
          Exportar a Excel
        </button>
        <button
          (click)="exportarCsv()"
          class="btn hover:medium-green flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
        >
          <mat-icon aria-hidden="false" aria-label="icono exportar venta" fontIcon="download" />
          Exportar a CSV
        </button>
        <button
          *ngIf="!ventaData.validado"
          (click)="toggleEdit()"
          class="btn hover:medium-green flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
        >
          <mat-icon aria-hidden="false" aria-label="icono editar venta" fontIcon="edit" />
          Editar
        </button>
        <button
          *ngIf="!ventaData.validado"
          (click)="mostrarDiaologoEliminar = true"
          class="btn hover:medium-alert flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-alert bg-alert px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
        >
          <mat-icon aria-hidden="false" aria-label="icono eliminar" fontIcon="delete" />
          Eliminar
        </button>
        <button
          *ngIf="!ventaData.validado"
          (click)="mostrarDialogoValidacion = true"
          class="btn hover:medium-green flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
        >
          <mat-icon aria-hidden="false" aria-label="icono editar venta" fontIcon="check" />
          Validar Venta
        </button>
        <button
          *ngIf="ventaData.validado"
          class="btn hover:disabled flex h-fit cursor-default items-center justify-center gap-2 rounded-lg border-2 border-blue bg-blue px-4 py-2 text-seasalt transition delay-100 ease-in"
        >
          <mat-icon aria-hidden="false" aria-label="icono editar venta" fontIcon="check" />
          Venta Validada
        </button>
      </ng-container>
      <ng-container *ngIf="isEditMode">
        <app-loading-button
          [text]="'Guardar'"
          [icon]="'save'"
          [loading]="isLoading"
          [disabled]="ventaForm.invalid || ventaForm.pending"
          (clicked)="guardarCambios()"
        />
        <button
          (click)="cancelarEdicion()"
          class="btn flex h-fit items-center justify-center gap-2 rounded-lg border-2 border-alert bg-alert px-4 py-2 text-seasalt transition delay-100 ease-in hover:border-alert hover:bg-seasalt hover:text-alert"
        >
          <mat-icon aria-hidden="false" aria-label="icono cancelar edición" fontIcon="cancel" />
          Cancelar
        </button>
      </ng-container>
    </div>
  </div>
  <form [formGroup]="ventaForm" class="mx-auto mb-32 w-[100%] space-y-6">
    <div class="card-shadow rounded-md p-4">
      <h2 class="mb-2 text-xl font-semibold text-field-green">Datos Generales</h2>
      <div class="mt-4 grid grid-cols-3 gap-4">
        <div>
          <app-input-fecha
            [formGroup]="ventaForm"
            controlName="fechaAsientoContable"
            label="Fecha del Asiento Contable"
          />
        </div>
        <div>
          <app-input-fecha [formGroup]="ventaForm" controlName="fechaValidacion" label="Fecha de Validación" />
        </div>
      </div>
      <div class="mt-4 grid grid-cols-3 gap-4">
        <!-- EMPRESA FACTURADORA -->
        <div>
          <label for="empresaFacturadoraId" class="block text-sm font-medium">Empresa</label>
          <select
            id="empresaFacturadoraId"
            formControlName="empresaFacturadoraId"
            class="delay-50 border-1 form-select mt-1 block w-full rounded-md border-dark-blue shadow-sm transition ease-in focus:border-medium-green focus:ring focus:ring-medium-green focus:ring-opacity-50"
          >
            <option *ngFor="let empresa of empresasRefacturadoras" [value]="empresa.id">
              {{ empresa.nombreEmpresa }}
            </option>
          </select>
          <app-form-errors fieldName="empresaFacturadoraId" />
        </div>

        <!-- METODO PAGO -->
        <div>
          <label for="metodoPagoId" class="block text-sm font-medium">Método de Pago</label>
          <select
            id="metodoPagoId"
            formControlName="metodoPagoId"
            class="delay-50 border-1 form-select mt-1 block w-full rounded-md border-dark-blue shadow-sm transition ease-in focus:border-medium-green focus:ring focus:ring-medium-green focus:ring-opacity-50"
          >
            <option *ngFor="let metodo of metodosPago" [value]="metodo.id">
              {{ metodo.nombre }}
            </option>
          </select>
          <app-form-errors fieldName="metodoPagoId" />
        </div>

        <!-- CUENTA BANCARIA -->
        <div *ngIf="metodoIsDomiciliacionBancaria()">
          <label for="cuentaBancariaId" class="block text-sm font-medium">Cuenta bancaria</label>
          <select
            id="cuentaBancariaId"
            formControlName="cuentaBancariaId"
            class="delay-50 border-1 form-select mt-1 block w-full rounded-md border-dark-blue shadow-sm transition ease-in focus:border-medium-green focus:ring focus:ring-medium-green focus:ring-opacity-50"
          >
            <option *ngFor="let cuenta of cuentasBancarias" [value]="cuenta.id">
              {{ cuenta.banco }} - {{ cuenta.numeroCuenta }}
            </option>
          </select>
          <app-form-errors fieldName="cuentaBancariaId" />
        </div>
      </div>
      <div class="mt-4 grid grid-cols-3 gap-4">
        <app-input-number [formGroup]="ventaForm" controlName="codAlbaranInicial" label="Código Albarán Inicial" />
        <div *ngIf="!ventaData.validado">
          <label class="block text-sm font-medium">&nbsp;</label>
          <button
            (click)="abrirModal('modalCambiarCodigoAlbaran')"
            class="btn flex items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:border-field-green hover:bg-seasalt hover:text-dark-blue"
          >
            <mat-icon aria-hidden="false" aria-label="icono cambiar código albarán" fontIcon="edit" />
            Cambiar Código Albarán
          </button>
        </div>
      </div>
    </div>
    <div class="card-shadow rounded-md p-4">
      <h2 class="mb-2 text-xl font-semibold text-field-green">Observaciones</h2>
      <div class="grid grid-cols-1 gap-4">
        <app-input-textarea label="Observaciones del venta" [formGroup]="ventaForm" controlName="observaciones" />
      </div>
    </div>
    <div class="card-shadow rounded-md p-4">
      <h2 class="mb-2 text-xl font-semibold text-field-green">Facturas Asociadas</h2>
      <ag-grid-angular
        style="min-width: 100%; height: 75vh"
        class="ag-theme-quartz mx-auto"
        [rowData]="ventaData.facturas"
        [columnDefs]="columnDefs"
        [gridOptions]="gridOptions"
      />
    </div>
  </form>
</div>

<app-async-confirmation-dialog
  [isOpen]="mostrarDialogoValidacion"
  [title]="'Validar venta'"
  [message]="'El asiento contable de venta será validado.'"
  [confirmButtonText]="'Validar Ventas'"
  [confirmButtonIcon]="'check'"
  [loading]="isLoadingValidar"
  (closed)="mostrarDialogoValidacion = false"
  (confirmed)="validarVenta()"
/>

<app-async-confirmation-dialog
  [isOpen]="mostrarDiaologoEliminar"
  [title]="'Eliminar venta'"
  [message]="'¿Está seguro de que desea eliminar este venta?'"
  [confirmButtonText]="'Eliminar'"
  [confirmButtonIcon]="'delete'"
  [isDeleteAction]="true"
  [loading]="isLoadingEliminar"
  (closed)="mostrarDiaologoEliminar = false"
  (confirmed)="eliminarVenta()"
/>

<!-- MODAL CAMBIAR CODIGO ALBARAN -->
<dialog
  id="modalCambiarCodigoAlbaran"
  class="bg-medium-yellow fixed left-1/2 top-1/2 mx-4 max-h-[80vh] w-4/5 max-w-3xl -translate-x-1/2 -translate-y-1/2 transform rounded-3xl p-6 md:mx-0"
>
  <div class="relative flex flex-col items-center justify-center gap-4">
    <div class="flex w-full items-center justify-between">
      <h2 class="my-3 self-start px-6 text-3xl font-bold text-field-green">Cambiar Código Albarán</h2>
      <div class="sticky right-3 top-0 z-10 flex justify-end">
        <button
          (click)="cerrarModal('modalCambiarCodigoAlbaran')"
          class="btn flex items-center justify-center rounded-xl border-2 border-medium-green bg-medium-green px-2 py-2 text-lg text-seasalt transition delay-100 ease-in hover:border-field-green hover:bg-seasalt hover:text-dark-blue"
        >
          <mat-icon fontIcon="close"></mat-icon>
        </button>
      </div>
    </div>
    <div
      id="contenidoPagarEfectivo"
      class="mb-4 flex w-full flex-col items-center justify-center gap-4 rounded-3xl bg-dark-blue py-6 font-semibold text-seasalt"
    >
      <p>Indique el nuevo código de albarán inicial para esta venta:</p>
      <div>
        <input
          [id]="nuevoCodigoAlbaran"
          [(ngModel)]="nuevoCodigoAlbaran"
          type="number"
          step="1"
          value="ventaData?.codAlbaranInicial"
          class="border-1 form-input mt-1 block w-full rounded-md border-dark-blue text-alert shadow-sm focus:border-medium-green focus:ring focus:ring-medium-green focus:ring-opacity-50"
        />
      </div>
      <p>¿Desea proseguir con la operación?</p>
    </div>
    <div>
      <app-loading-button
        [text]="'Cambiar Código Albarán'"
        [icon]="'reply'"
        [loading]="isLoadingCambiarCodigoAlbaran"
        [disabled]="!nuevoCodigoAlbaran || nuevoCodigoAlbaran === ventaData.codAlbaranInicial"
        (clicked)="cambiarCodigoAlbaran()"
      />
    </div>
  </div>
</dialog>
